import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import PersonligKontakt from "./sections/PersonligKontakt";
import GroundworkDrainage from "./sections/GroundworkDrainage";
import HerFinnerDuOss from "./sections/HerFinnerDuOss";
import ContactForm from "./sections/ContactForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <PersonligKontakt />
      <GroundworkDrainage />
      <HerFinnerDuOss />
      <ContactForm />
      <Footer />
    </div>;
}